import { Box, Stack, styled, Tooltip } from "@mui/material"
import { useLocalization } from "@tm/localization"
import { classes, TmaHelper } from "@tm/utils"
import { ECounterType } from "@tm/models"
import { Icon } from "../../../../../muiStyled/DataDisplay/Icons"
import { Image } from "../../../Image"
import { TyreTileAttributesIcons } from "./TyreTileAttributesIcons"
import { ArticleNumbers } from "../../../ArticleNumbers"
import { Supplier } from "../../../Supplier"
import { useDefaultArticleItemState } from "../../../ContextProviderStates/DefaultArticleItemState"
import { DefaultArticleErpContainer } from "../../../ErpContainer"
import { Transactions } from "../../../Transactions"
import { DetailsButton } from "../../../Actions/DetailsButton"
import { ExpandIconButton } from "../../Default/ArticleItemComponents"
import { Attributes } from "../../../Attributes"
import { CompactAttributes } from "../../../Attributes/CompactAttributes"
import { Descriptions } from "../../../Descriptions"
import { TileWrapper } from "../../../StyledComponents"
import { ErpAreaActions } from "../../../Actions/ErpAreaActions"

const StyledTopBox = styled(Box)(() => ({
    width: "100%",
    display: "flex",
    boxSizing: "border-box",
    justifyContent: "space-between",
    alignItems: "flex-start",
}))

const StyledBottomBox = styled(Box)(() => ({
    flex: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    ".f": {
        margin: 0,
    },
    ".supplierArticleNoContainer": {
        overflow: "hidden",
        ".MuiButton-root": {
            width: "-webkit-fill-available",
            ".MuiTypography-root": {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
            },
        },
    },

    ".compact-attributes, .attributes": {
        flex: "unset",
        margin: 0,
        ".flex-shrink": {
            flex: "unset",
        },
    },
}))

const RightInnerContainer = styled(Box, {
    shouldForwardProp: (prop: string) => !["showExtendedAvailabilityContainer"].includes(prop),
})<{ showExtendedAvailabilityContainer?: boolean }>(({ showExtendedAvailabilityContainer }) => ({
    gap: 4,
    flexDirection: "column",
    display: "flex",
    ".erpContainer": {
        ".availabilityContainer": {
            width: showExtendedAvailabilityContainer ? 104 : undefined,
            ".availability-icon-with-tour": {
                minWidth: 0,
            },
        },
        "& > div:last-of-type": {
            minWidth: "5.2em",
        },
    },
    ".transactions": {
        ".basketAmountField": {
            ".MuiInputBase-input": {
                paddingLeft: 4,
                width: 40,
            },
            "&[data-has-amountinfo] .MuiInputBase-input": {
                width: 56,
            },
        },
        ".addToBasketButton": {
            width: "6rem",
        },
        ".costEstimationButton .MuiButton-startIcon>svg.icon": {
            width: "auto",
        },
        justifyContent: "left",
    },
}))

export function TyresTile() {
    const showExtendedAvailabilityContainer = useDefaultArticleItemState((x) => x.showExtendedAvailabilityContainer)
    const { translateText } = useLocalization()
    const toggleExpand = useDefaultArticleItemState((x) => x.toggleExpand)
    const expanded = useDefaultArticleItemState((x) => x.expanded)

    const handleExpand = () => {
        TmaHelper.GeneralCountEvent.Call(ECounterType.ArticleListExpandArticle, true)
        toggleExpand()
    }

    return (
        <TileWrapper className={classes(expanded && "expanded")}>
            <StyledTopBox>
                <DetailsButton />
                <Box display="flex" flex={1} justifyContent="center">
                    <Image size={130} marginTop={1} />
                </Box>
                <TyreTileAttributesIcons />
            </StyledTopBox>
            <StyledBottomBox>
                <Stack height="55%" justifyContent="space-between" gap={0.5}>
                    <Stack>
                        <Stack>
                            <Supplier compactView marginTop={0} fitContent />
                            <ArticleNumbers />
                        </Stack>
                        <Stack flexDirection="row" alignItems="end" justifyContent="space-between">
                            <Descriptions oneLine={!expanded} hideImsIcons={!expanded} sx={{ pl: "2px", maxWidth: "90%" }} />
                            {/* Expand Icon */}
                            <Tooltip title={translateText(expanded ? 13862 : 12569)}>
                                <ExpandIconButton onClick={handleExpand} hoverEffect disableRipple>
                                    <Icon name={expanded ? "minus" : "plus"} />
                                </ExpandIconButton>
                            </Tooltip>
                        </Stack>
                    </Stack>
                    {expanded ? <Attributes /> : <CompactAttributes />}
                </Stack>
                <RightInnerContainer showExtendedAvailabilityContainer={showExtendedAvailabilityContainer}>
                    <ErpAreaActions sx={{ alignItems: "start", flexDirection: "row", gap: 1 }} />
                    <DefaultArticleErpContainer hideErpAreaActions suppressPriceFontCustomization />
                    <Transactions displayMoreMenuButton />
                </RightInnerContainer>
            </StyledBottomBox>
        </TileWrapper>
    )
}
